import { Component, OnInit } from '@angular/core';
import { BatchService } from '../../../services/batch.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidator } from '../../../services/custom-validator';
import { PaginationInstance } from 'ngx-pagination';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';
import { DateTimeService } from '../../../services/date-time.service';
import { Utils } from '../../../services/utils';
import { GenericModalService } from '../../../services/generic-modal.service';
import { BatchManagementModalComponent } from './batch-management-modal/batch-management-modal.component';

@Component({
  selector: 'app-batch-management',
  templateUrl: './batch-management.component.html',
  styleUrls: ['./batch-management.component.css']
})
export class BatchManagementComponent implements OnInit {

  searchDone = false;
  filterReportForm: FormGroup;
  errorMessage = '';
  pleaseWait = false;
  batches = [];
  config: PaginationInstance;
  p = 1;
  total: number;
  utilsFunctions = Utils;
  inProcess = false;
  lastPageIndex: number;
  batchSubmissionLifeCycle = [
    {id: 0, description: 'Nenhum'},
    {id: 1, description: 'Criado'},
    {id: 2, description: 'Processando'},
    {id: 4, description: 'Finalizado'},
    {id: 8, description: 'Pausado automaticamente'},
    {id: 16, description: 'Pausado por usuário'},
    {id: 32, description: 'Cancelado automaticamente'},
    {id: 64, description: 'Cancelado por usuário'},
  ];
  private _hilo = 0;

  get formData() { return this.filterReportForm.controls; }
  get sessionId() { return `batch${new Date().getTime()}@${++this._hilo}`}

  constructor(
    private batchService: BatchService,
    private formBuilder: FormBuilder,
    private webClientConfig: WebClientConfigurationService,
    private dateTimeService: DateTimeService,
    private genericModalService: GenericModalService
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.filterReportForm = this.formBuilder.group({
      batchName: '',
      initialCreationDate: [ this.currentDayInterval().start, [Validators.required] ],
      finalCreationDate: [ this.currentDayInterval().end, [Validators.required] ],
      batchSubmissionLifeCycle: [0, [Validators.required]],
      pageIndex: 1
    });
    this.filterReportForm.setValidators(CustomValidator.validateDatetime('initialCreationDate', 'finalCreationDate'));
  }

  currentDayInterval = function() {
    const now = new Date();
    return {
      start: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)).toISOString()
        .substr(0, 16),
      end: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)).toISOString()
        .substr(0, 16)
    };
  };

  search(page: number) {
    this.lastPageIndex = page;
    this.errorMessage = '';
    this.pleaseWait = true;
    const filter = this.filterReportForm.getRawValue();
    filter.pageIndex = page;
    filter.initialCreationDate = this.dateTimeService.toUTC(filter.initialCreationDate);
    filter.finalCreationDate = this.dateTimeService.toUTC(filter.finalCreationDate);
    this.batchService.searchPagedBatchSubmission(filter)
      .subscribe( result => {
        this.total = result.total;
        this.p = 1;
        this.getPaginationConfig(page, result.total);
        this.batches = result.items;
        this.pleaseWait = false;
        this.searchDone = true;
        this.collapseFilter(true);
      },
error1 => {
        this.errorMessage = error1;
        this.pleaseWait = false;
      });
  }

  getPaginationConfig(_currentPage: number, _totalItems: number) {
    this.errorMessage = '';
    this.webClientConfig.getPageSizeConfig()
      .subscribe(item => {
        this.config  = {
          id: 'server',
          itemsPerPage: item,
          currentPage: _currentPage,
          totalItems: _totalItems
        };
      }, error1 => this.errorMessage = error1);
  }

  showValidationError(error: any) {
    const errorObject = JSON.parse(error);
    this.genericModalService.showInfoMessage(errorObject['Exception'].Message, true, 12000, 'Erro');
  }

  generatePercentGraph(specific, total) {
    let html = '<div style="border: 1px solid #000; height: 12px;">';
    const percent = (specific / total) * 100;
    const width = this.getPercentBasedWidth(percent);
    if (percent > 0) {
      html += `<div class="graphCell">
                  <div class="graphBar" style="width:${width}%; background-color: #17a2b8; height: 10px;"></div>
                </div>`;
    }
    html += '</div>';
    return html;
  }

  generatePercentLabel(specific, total) {
    const percent = (specific / total) * 100;
    let label = percent.toFixed(2).replace('.', ',');
    if (label.toString().indexOf(',00') > -1) {
      label = label.replace(',00', '');
    }
    return `${label}%`;
  }

  getPercentBasedWidth(item) {
    return (item / 100) * parseInt('100', 10) || 100;
  }

  downloadCsv(batchSubmissionId: number, batchSubmissionName: string) {
    this.errorMessage = '';
    this.batchService.getErrorBatchItems(batchSubmissionId)
      .subscribe(data => {
          const fileName = `${batchSubmissionName}_ErrorItems.csv`;
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = encodeURIComponent(fileName);
          a.href = URL.createObjectURL(data);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
        },
        err => {
          this.errorMessage = err;
          console.log(err);
        }
      );
  }

  continueBatch(batchSubmissionId: number) {
    this.errorMessage = '';
    this.inProcess = true;
    this.batchService.continueBatchSubmission(batchSubmissionId)
      .subscribe( () => { this.search(this.lastPageIndex); this.inProcess = false; },
        error1 => this.errorMessage = error1 );
  }

  pauseBatch(batchSubmissionId: number) {
    this.errorMessage = '';
    this.inProcess = true;
    this.batchService.pauseBatchSubmission(batchSubmissionId)
      .subscribe( () => { this.search(this.lastPageIndex); this.inProcess = false; },
        error1 => this.errorMessage = error1 );
  }

  cancelBatch(batchSubmissionId: number) {
    this.errorMessage = '';
    this.inProcess = true;
    this.batchService.cancelSubmission(batchSubmissionId)
      .subscribe( () => { this.search(this.lastPageIndex); this.inProcess = false; },
        error1 => this.errorMessage = error1 );
  }

  finishBatch(batchSubmissionId: number) {
    this.errorMessage = '';
    this.inProcess = true;
    this.batchService.finishBatchSubmission(batchSubmissionId)
      .subscribe( () => { this.search(this.lastPageIndex); this.inProcess = false; },
        error1 => this.errorMessage = error1 );
  }

  isDisabledByOption(option: string, lifeCycle: number): boolean {
    let isDisable: boolean;
    switch (option) {
      case 'cancel':
      case 'pause': isDisable = lifeCycle !== 2;
        break;
      case 'resume': isDisable = lifeCycle !== 16;
        break;
      case 'finish': isDisable = lifeCycle !== 16 && lifeCycle !== 2;
        break;
    }
    return isDisable;
  }

  collapseFilter(collapse: boolean) {
    if (collapse) {
      // @ts-ignore
      $('#cardFilter').CardWidget('collapse');
    } else {
      // @ts-ignore
      $('#cardFilter').CardWidget('expand');
    }
  }

  blockUserInput() {
    return false;
  }

  newBatch() {
    const destComponent: any = BatchManagementModalComponent;
    const objInitialState = this.sessionId;
    const result$ = this.genericModalService.showObjModal(destComponent, 'Novo Lote', objInitialState, 'modal-lg');
    if (result$) {
      result$.asObservable()
        .subscribe(
          result => {
            if (result) {
              // realizar a pesquisa do dia...
              this.search(1);
            }
          }
        );
    }
  }

}
